import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { AboutPage } from './pages/AboutPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col w-full bg-nude-light" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/services" element={<ServicesPage data-id="element-9" />} data-id="element-8" />
            <Route path="/about" element={<AboutPage data-id="element-11" />} data-id="element-10" />
            <Route path="/testimonials" element={<TestimonialsPage data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
          </Routes>
        </main>
        <Footer data-id="element-16" />
      </div>
    </Router>;
}